import Ajax from '@lib/ajax'

export default {
  async updateSetting(id, value) {
    return Ajax.put("/api/services/app/Configuration/updateSetting", {
        id: null,
        value: value,
        name: id
    }).then(response => {
        return response.data.result;
    });
  },
  async getSettingGridResult(payload){
    return Ajax.get('/api/services/app/Configuration/GetSettingGridResult', payload);
  }
}